import React from "react";
import Modal from "@mui/material/Modal";
import {LoadingSpinner} from "components/Icons";
import CustomButton from "./CustomButton";
const ConfirmPopup = ({ open, onClose, confirmContent, confirmDescription, onConfirm, isLoading=null, cancelText="キャンセル", confirmText="削除する", width=448, type="normal" }: any) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div style={{minWidth: `${width}px`, maxWidth: `${width}px`}} className="bg-white rounded-2xl p-6 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] outline-none">
        <h2 className="text-2xl font-bold alu-text-base-2">
          {confirmContent}
        </h2>
        <p className="mt-6 text-sm alu-text-base-2">{confirmDescription}</p>
        <div className="flex items-center justify-center gap-8 mt-10">
          <CustomButton variant={type === "delete" ? "danger_text" : "text"} type="button" onClick={onClose}>
            {cancelText}
          </CustomButton>
          <CustomButton
            variant={type === "delete" ? "danger" : "default"}
            size="md"
            type="button" 
            disabled={isLoading}
            onClick={onConfirm}
          >
            {isLoading !== null ? <><p>{isLoading ? "保存中..." : confirmText}</p>
              {isLoading && (
                <span><LoadingSpinner/></span>
              )}</> : <p>{confirmText}</p>
            }
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmPopup;